import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { ProcessType } from "../../../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { ExternalDocumentType } from "../../../../../../../../Wrap/Models/Domains/Documents/ExternalDocumentType";
import { DocumentTaskRequestModel } from "../../../../../../../../Wrap/Models/Models/Tasks/DocumentTaskRequestModel";
import { processTypeEnum } from "../../../../Common/Resource/Contents";

export class DocumentsHelper {
    static getTaskRequest(
        instructionId: string,
        customerid: string,
        claccountid: string,
        hierarchyid: string,
        type: DocumentTaskRequestTypeEnum,
        processType: processTypeEnum
    ): DocumentTaskRequestModel {
        const request: DocumentTaskRequestModel = {
            Type: type,
            CustomerId: customerid,
            ClAccountId: claccountid,
            HeadAccountHierarchyId: hierarchyid,
        };
        if (processType == processTypeEnum.NewBusiness || processType == processTypeEnum.Quote) {
            request.Parameters = "AccountInstructionId=" + instructionId;
        } else {
            if (
                (processType == processTypeEnum.NewBusinessExistingClient ||
                    processType == processTypeEnum.NewQuoteExistingClient) &&
                type == DocumentTaskRequestTypeEnum.TransferForm
            ) {
                request.Parameters = "AccountInstructionId=" + instructionId;
            } else {
                request.InstructionHierarchyId = instructionId;
            }

            if (processType == processTypeEnum.SinglePaymentTransfer && type == DocumentTaskRequestTypeEnum.ChargeSummary) {
                request.Parameters = "IsDetailed=True";
            }
        }

        request.ProcessType = this.getProcessType(processType);
        return request;
    }

    static getProcessType = (processType: processTypeEnum): ProcessType => {
        if (processType == processTypeEnum.NewBusiness) {
            return ProcessType.NewBusiness;
        }
        if (processType == processTypeEnum.NewBusinessExistingClient) {
            return ProcessType.NewBusinessExistingClient;
        }
        if (processType == processTypeEnum.Quote) {
            return ProcessType.Quote;
        }
        if (processType == processTypeEnum.SinglePaymentTransfer) {
            return ProcessType.AddSinglePaymentorTransfer;
        }
        if (processType == processTypeEnum.RegularPayment) {
            return ProcessType.AddRegularPayment;
        }
        if (processType == processTypeEnum.topUpWithITFLS) {
            return ProcessType.Topup;
        }
        return ProcessType.NotSpecified;
    };

    static getTaskRequestForChargeInformation(
        batchId: number,
        claccountid: string,
        type: DocumentTaskRequestTypeEnum
    ): DocumentTaskRequestModel {
        const request: DocumentTaskRequestModel = {
            Type: type,
            ClAccountId: claccountid,
        };
        request.Parameters = "BatchId=" + batchId;
        request.ProcessType = ProcessType.Switch;
        return request;
    }

    static getTaskRequestForDirectDebitInstruction(
        instructionId: string,
        customerid: string,
        claccountid: string,
        hierarchyid: string,
        processType: processTypeEnum,
        bankAccountId?: number,
        bankAccountInstructionId?: number
    ): DocumentTaskRequestModel {
        const request: DocumentTaskRequestModel = {
            Type: DocumentTaskRequestTypeEnum.DirectDebitInstruction,
            CustomerId: customerid,
            ClAccountId: claccountid,
            HeadAccountHierarchyId: hierarchyid,
        };
        request.Parameters = "";
        if (processType == processTypeEnum.NewBusiness || processType == processTypeEnum.Quote) {
            request.Parameters = "AccountInstructionId=" + instructionId;
        } else {
            request.InstructionHierarchyId = instructionId;
        }
        if (bankAccountId > 0) {
            if (request.Parameters?.length > 0) {
                request.Parameters += "|";
            }
            request.Parameters += "BankAccountId=" + bankAccountId;
        }
        if (bankAccountInstructionId > 0) {
            if (request.Parameters?.length > 0) {
                request.Parameters += "|";
            }
            request.Parameters += "BankAccountInstructionId=" + bankAccountInstructionId;
        }
        return request;
    }

    static getTaskRequestFortInvestmentDocumentsInstruction(
        instructionId: string,
        customerid: string,
        claccountid: string,
        company: string,
        externalDocumentType: ExternalDocumentType,
        processType: processTypeEnum,
        type: DocumentTaskRequestTypeEnum,
        hierarchyid: string
    ): DocumentTaskRequestModel {
        const request: DocumentTaskRequestModel = {
            Type: type,
            CustomerId: customerid,
            ClAccountId: claccountid,
            HeadAccountHierarchyId: hierarchyid,
            InstructionHierarchyId: instructionId,
            ExternalDocumentType: externalDocumentType,
        };
        request.Parameters = "";
        if (processType == processTypeEnum.NewBusiness || processType == processTypeEnum.Quote) {
            request.Parameters = "AccountInstructionId=" + instructionId;
        } else {
            if (
                (processType == processTypeEnum.NewBusinessExistingClient ||
                    processType == processTypeEnum.NewQuoteExistingClient) &&
                type == DocumentTaskRequestTypeEnum.TransferForm
            ) {
                request.Parameters = "AccountInstructionId=" + instructionId;
            } else {
                request.InstructionHierarchyId = instructionId;
            }
        }
        if (!CommonHelper.isNullOrEmpty(claccountid)) {
            request.Parameters += "|ClAccountId=" + claccountid;
        }
        if (!CommonHelper.isNullOrEmpty(customerid)) {
            request.Parameters += "|CustomerId=" + customerid;
        }
        if (!CommonHelper.isNullOrEmpty(company)) {
            request.Parameters += "|Company=" + company;
        }
        if (!CommonHelper.isNullOrEmpty(externalDocumentType)) {
            request.Parameters += "|ExternalDocumentType=" + externalDocumentType;
        }
        request.ProcessType = this.getProcessType(processType);
        return request;
    }
}
